export default __webpack_public_path__ + "3d0d06781cf80c51168740367dc775bc.png";